export enum ClinicType {
  Private = 0,
  State = 1
}
